export default __webpack_public_path__ + "static/media/rank.414ac80a.svg";